import { Inline } from 'canoe';
import React from 'react';

import { ValueButton, ValueGroup } from '@candu-ai/craft/ui';
import { DismissIconSettings } from 'craft/components/DismissIconSettings';
import { Section } from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks';
import { CssSelectorId } from 'craft/types';

enum DismissBehaviour {
  Minimize = 'minimize',
  Dismiss = 'dismiss',
}

export const HotspotDismiss = ({ nodeIds }: { nodeIds: string[] }) => {
  const {
    props: { dismissBehaviour },
    actions: { setProps },
  } = useMultiNodes(nodeIds);

  const dismissOnClose = dismissBehaviour.value === DismissBehaviour.Dismiss;

  return (
    <Section name="Dismissible Hotspot">
      <ValueGroup>
        <Inline space="xs" align="center" fillSpace>
          <ValueButton
            isActive={!dismissOnClose}
            onClick={() => setProps({ dismissBehaviour: DismissBehaviour.Minimize })}
          >
            Minimize
          </ValueButton>
          <ValueButton
            isActive={dismissOnClose}
            onClick={() => setProps({ dismissBehaviour: DismissBehaviour.Dismiss })}
          >
            Dismiss
          </ValueButton>
        </Inline>
      </ValueGroup>

      <DismissIconSettings
        nodeIds={nodeIds}
        dismissCssSelector={CssSelectorId.HotspotDismiss}
        dismissSVGCssSelector={CssSelectorId.HotspotDismissSVG}
      />
    </Section>
  );
};
